<template>
    <section class="c-teacher-rc">
        <div class="w1190-center pt30-b20">
            <div class="c-teacher-rc-header">
                <h1 class="c-teacher-rc-h1 m0">名师推荐</h1>
            </div>
            <div class="c-teacher-rc-body flex flex-vertical-center flex-between">
                <c-tag
                    v-if="teacherList.length > 1"
                    :size="54"
                    class="c-teacher-rc-prev"
                    bg-color="#2F2A2F"
                    hover-color="orange"
                    type="circle"
                    @mouseenter.native="handleToggleAutoPlay(false)"
                    @mouseleave.native="handleToggleAutoPlay(true)"
                    @click.native="prev"
                >
                    <i class="el-icon-sort-down"></i>
                </c-tag>
                <div class="c-teacher-rc-container">
                    <el-carousel
                        ref="carousel"
                        arrow="never"
                        indicator-position="none"
                        :autoplay="autoplay"
                        height="521px"
                        @change="handleChangeIndex"
                    >
                        <el-carousel-item
                            v-for="item in teacherList"
                            :key="item.id"
                            class="c-teacher-rc-item flex flex-vertical-end flex-between"
                        >
                            <img
                                v-lazy="item.teacher"
                                class="c-teacher-rc-img-big"
                                alt="教师名字"
                            />
                            <div class="c-teacher-rc-detail flex flex-column flex-between">
                                <div>
                                    <div class="flex flex-vertical-center flex-between">
                                        <div>
                                            <span class="c-teacher-rc-chinese color-orange">
                                                {{ item.name }}
                                            </span>
                                            <span class="c-teacher-rc-name capitalize">
                                                {{ item.englishName }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="c-teacher-rc-text mt2">
                                        <span class="color-orange">学科：</span>
                                        <span class="color-white"
                                            >{{ item.grade }}{{ item.suject }}</span
                                        >
                                    </div>
                                    <div class="c-teacher-rc-text c-teacher-rc-intro scrollbar">
                                        <span class="color-orange">简介：</span>
                                        <span class="color-white">{{ item.intro }} </span>
                                    </div>
                                </div>
                                <div
                                    class="flex flex-start c-teacher-rc-indicators-placeholder"
                                ></div>
                            </div>
                        </el-carousel-item>
                        <div class="flex flex-start c-teacher-rc-indicators">
                            <img
                                v-for="(teacher, index) in teacherList"
                                :key="teacher.id"
                                v-lazy="teacher.teacher"
                                :alt="teacher.name"
                                :class="[
                                    'c-teacher-rc-indicator',
                                    { active: index === activeIndex }
                                ]"
                                @click="handleChange(index)"
                            />
                        </div>
                    </el-carousel>
                </div>
                <c-tag
                    v-if="teacherList.length > 1"
                    :size="54"
                    class="c-teacher-rc-next"
                    bg-color="#2F2A2F"
                    hover-color="orange"
                    type="circle"
                    @mouseenter.native="handleToggleAutoPlay(false)"
                    @mouseleave.native="handleToggleAutoPlay(true)"
                    @click.native="next"
                >
                    <i class="el-icon-sort-down"></i>
                </c-tag>
            </div>
        </div>
    </section>
</template>

<script>
import CTag from '@components/CTag.vue';

export default {
    components: {
        CTag
    },
    data() {
        return {
            activeIndex: 0,
            teacherList: [
                {
                    id: 1,
                    name: '刘航',
                    englishName: 'liu hang',
                    suject: '历史',
                    grade: '初中',
                    studyAge: 13,
                    intro:
                        '级部负责人。获2017年“一师一优课”、“部级优课”；获重庆市2018年初中历史优质课大赛“一等奖”；作为课题主研人员参与多项重庆市教育科学“十二五”规划重点课题。',
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/liuhang.png'
                },
                {
                    id: 2,
                    name: '戴智丽',
                    grade: '初中',
                    englishName: 'dai zhili',
                    suject: '英语',
                    intro:
                        '初中级部主任。2019年重庆市主题班会一等奖；论文获重庆市一等奖、二等奖；江北区2018-2019年度优秀班主任；渝中区2017-2018年度优秀教师；2018年“一师一优课”江北区二等奖；巴蜀中学初2021届英语教研组组长；巴蜀中学优秀班主任；巴蜀中学优秀共产党员；多次获得巴蜀中学青年教师解题大赛、优质课、主题班会、教案评比一等奖；参与编写多套教辅资料',
                    studyAge: 13,
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/daizhili.png'
                },
                {
                    id: 3,
                    name: '郑军',
                    grade: '高中',
                    englishName: 'zheng jun',
                    suject: '化学',
                    intro:
                        '高中级部主任，巴蜀中学高2021届化学教研组组长。高考阅卷组组长；获重庆市优质课大赛一等奖1次，全国一等奖2次；多篇论文发表于《化学教育》、《化学教学》、《中学化学教学参考》；多篇论文获国家级、市级一等奖；主研中国化学会规划课题3项、主研全国教育科学规划；国家课题子课题1项；西南大学教师教育学院“面向新高考的教师专业发展能力提升项目名师名校跟岗”学科导师；区级优秀骨干教师、区级优秀共产党员；巴蜀中学解题能力大赛一等奖',
                    studyAge: 13,
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/zhengjun.png'
                },
                {
                    id: 4,
                    name: '江天龙',
                    englishName: 'jiang tianlong',
                    grade: '高中',
                    suject: '数学',
                    intro:
                        '从教十二年，教学成绩显著，多名高三毕业生考入清华；北大等国内外知名学府；巴蜀中学高2021届数学教研组组长；巴蜀中学高2021届清华美术班数学老师；多次荣获巴蜀中学优秀教师、优秀党员称号；多次在巴蜀中学青年教师解题能力大赛、青年教师优质课大赛中获奖；多篇论文发表于各省、市级期刊。',
                    studyAge: 13,
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/jiangtianlong.png'
                },
                {
                    id: 5,
                    name: '刘洁丽',
                    englishName: 'liu jieli',
                    grade: '初中',
                    suject: '政治',
                    intro:
                        '2020年重庆市政治优质课大赛一等奖；2013年巴蜀中学优质课第一名；2013年巴蜀中学班主任心理课二等奖；2013年巴蜀中学杏坛新秀；2016年巴蜀中学解题能力大赛第二名；2019年巴蜀中学解题能力大赛第三名；2020年巴蜀中学优质课第一名',
                    studyAge: 13,
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/liujieli.png'
                },
                {
                    id: 6,
                    name: '赵萍萍',
                    englishName: 'zhao pingping',
                    grade: '高中',
                    suject: '语文',
                    intro:
                        '重庆市高考阅卷组组长；巴蜀中学高2021届语文教研组组长；中国陶行知研究会中国教育委员全国课堂教学大赛全国一等奖；重庆市首届心理活动课大赛市级一等奖；第九届重庆市中小学班主任基本功大赛全能一等奖；重庆市第五届中小学教育教学优秀论文评比市级一等奖；重庆市中学语文现场论文大赛市级一等奖；重庆市第十六届全市基础教育课程改革征文大赛市级一等奖；2019年“渝中区优秀教师”；多次评为巴蜀中学优秀班主任、优秀共产党员；另有多篇论文荣获市级、国家级奖项，并在知名刊物发表。',
                    studyAge: 13,
                    teacher:
                        'http://51haoke.oss-cn-hangzhou.aliyuncs.com/avatars/teachers_show/zhaopingping.png'
                }
            ],
            autoplay: true
        };
    },
    methods: {
        toTeacher(teacher) {
            this.$router.push({
                name: 'Teacher',
                params: {
                    id: teacher.id
                }
            });
        },
        prev() {
            this.$refs.carousel.prev();
        },
        next() {
            this.$refs.carousel.next();
        },
        handleChangeIndex(index) {
            this.activeIndex = index;
        },
        handleChange(index) {
            this.$refs['carousel'].setActiveItem(index);
        },
        handleToggleAutoPlay(autoplay) {
            this.autoplay = autoplay;
        }
    }
};
</script>

<style lang="scss" scoped>
.mt2 {
    margin-top: 2px;
}
.c-teacher-rc {
    width: 100%;
    height: 646px;
    background-image: url('~@images/bg.jpg');
    background-color: #f4f3f7;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    &-prev,
    &-next {
        transform: rotate(90deg);
        opacity: 0.5;
        font-weight: bold;
        font-size: 30px;
        cursor: pointer;
        &:hover {
            opacity: 1;
        }
    }
    &-h1 {
        font-size: 20px;
    }
    &-next {
        transform: rotate(90deg) rotateX(180deg);
    }
    &-container {
        width: 990px;
        height: 521px;
    }
    &-item {
        background-image: url('~@images/teacher-bg.png');
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 990px 486px;
        display: flex;
    }
    &-img {
        &-big {
            width: 312px;
            height: 521px;
            object-fit: contain;
            object-position: center bottom;
            margin: 0 42px;
        }
    }
    &-detail {
        flex: 1;
        height: 454px;
        padding: 30px 40px;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.8;
    }
    &-chinese {
        font-size: 26px;
    }
    &-name {
        color: #3a3a45;
        font-size: 26px;
        padding-left: 17px;
    }
    &-btn {
        padding: 13px 75px;
        font-size: 18px;
        font-weight: normal;
        box-shadow: 0px 5px 18px 0px #6e0a7b;
    }
    &-text {
        & + & {
            margin-top: 4px;
        }
    }
    &-intro {
        height: 210px;
        text-align: justify;
        overflow: auto;
    }
    &-line {
        width: 456px;
        height: 1px;
        background: #3a3a4a;
    }
    &-s {
        margin-top: 22px;
        color: #b1b1c3;
        line-height: 1.8;
        &-avatar {
            width: 50px;
            height: 50px;
            margin-right: 14px;
        }
        &-school {
            font-size: 12px;
        }
        &-desc {
            margin-top: 22px;
            font-size: 14px;
            text-align: justify;
        }
    }
    &-indicator {
        width: 50px;
        height: 50px;
        margin-right: 14px;
        opacity: 0.63;
        box-sizing: border-box;
        border-radius: 50%;
        object-fit: cover;
        object-position: center top;
        border: 2px solid #888888;
        background-color: #272733;
        cursor: pointer;
        &.active {
            opacity: 1;
            border-color: #feba72;
        }
    }
    &-indicators-placeholder {
        padding-top: 20px;
        height: 50px;
        border-top: 1px solid #5b5b68;
    }
    &-indicators {
        position: absolute;
        left: 434px;
        bottom: 30px;
        z-index: 2;
    }
}
</style>
